import Cookie from "js-cookie";
import query from "utils/query";
import RIDE_CREDIT_CREATE_MUTATION from "queries/mutations/createRideCredit";
import RIDE_CREDIT_UPDATE_MUTATION from "queries/mutations/updateRideCredit";
import RIDE_CREDIT_DELETE_MUTATION from "queries/mutations/deleteRideCredit";

export async function createRideCredit(
  values,
  setSubmitting,
  attraction,
  setOpen,
  mutate
) {
  const token = Cookie.get("token");
  setSubmitting(true);
  const variables = {
    attraction: attraction.id,
    rideDate: new Date(values.rideDate),
    rideTime: values.rideTime,
    ridePosition: values.ridePosition,
    rideRow: values.rideRow,
    rideSide: values.rideSide,
  };
  await query(RIDE_CREDIT_CREATE_MUTATION, { variables, token });
  mutate();
  setSubmitting(false);
  setOpen(false);
}

export async function deleteRideCredit(variables, mutate) {
  const token = Cookie.get("token");
  await query(RIDE_CREDIT_DELETE_MUTATION, { variables, token });
  mutate();
}

export async function updateRideCredit(variables, setCreditPending, mutate) {
  const token = Cookie.get("token");
  setCreditPending(true);
  await query(RIDE_CREDIT_UPDATE_MUTATION, { variables, token });
  mutate();
  setCreditPending(false);
}
